import { jsx } from 'panel';
import { ModalEl } from 'common/components/modal';
import { InputEl } from 'common/components/input';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import { SelectEl } from 'common/components/select';
import { RadioButtonEl } from 'common/components/radio-button';
import { ButtonEl } from 'common/components/button';
import { Placement } from 'common/components/tooltip/types';
import { ButtonTheme } from 'common/components/button/constants';
import { Permission } from 'common/report/constants';
export function template() {
  const {
    selectedDataResidency,
    timezones,
    selectedTimezone,
    projectName,
    selectedOrganizationId
  } = this.state;
  const orgData = this.attr("orgs");
  const isSetup = this.attr("is-setup");
  return jsx(ModalEl, {
    sel: '.project-creation',
    attrs: {
      open: this.attr("open")
    }
  }, jsx("div", {
    sel: '.mp-modal-content'
  }, jsx("div", {
    sel: '.mp-modal-title'
  }, "Create Project"), jsx(InputEl, {
    sel: '.project-name-input',
    attrs: {
      label: "Project Name",
      placeholder: "e.g. Production Analytics"
    },
    on: {
      input: ev => this.update({
        projectName: ev.target.value
      })
    },
    hook: {
      insert: _ref => {
        let {
          elm
        } = _ref;
        return requestAnimationFrame(() => elm.focus());
      }
    }
  }), jsx("div", {
    sel: '.data-residency-radio-group'
  }, jsx("div", {
    sel: '.label'
  }, "Select Where To Store Your Data", jsx("div", {
    sel: '.info'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    }
  }), jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom,
      'max-width': "300px"
    }
  }, "If you are a Mixpanel customer in the EU, you have the option to send your data to Mixpanel's EU data center. You do not lose any product capability if you choose to store your data in the EU."))), jsx("div", {
    sel: '.radio-btn',
    on: {
      click: () => this.update({
        selectedDataResidency: "US"
      })
    }
  }, jsx(RadioButtonEl, {
    attrs: {
      selected: selectedDataResidency === "US"
    }
  }, "\uD83C\uDDFA\uD83C\uDDF8 United States")), jsx("div", {
    sel: '.radio-btn',
    on: {
      click: () => this.update({
        selectedDataResidency: "EU"
      })
    }
  }, jsx(RadioButtonEl, {
    attrs: {
      selected: selectedDataResidency === "EU"
    }
  }, "\uD83C\uDDEA\uD83C\uDDFA European Union"))), jsx("div", {
    sel: '.timezones-dropdown-area'
  }, jsx("div", {
    sel: '.timezones-label'
  }, "Select Your Timezone"), jsx(SelectEl, {
    sel: '.timezones-dropdown',
    attrs: {
      options: timezones.map(timezoneEntry => timezoneEntry[1]),
      'label-transform': "uppercase",
      tabindex: 0,
      'selected-option': selectedTimezone ? selectedTimezone[1] : ""
    },
    on: {
      change: this.helpers.handleChangeSelectedTimezone
    }
  })), orgData && orgData.length > 1 && jsx("div", {
    sel: '.select-org'
  }, jsx("div", {
    sel: '.select-org-label'
  }, "Select Organization"), jsx("div", {
    sel: '.mp-chrome-create-project-modal-radio-button-container'
  }, orgData.map(org => {
    const disabled = !this.helpers.orgHasPerm(org, Permission.CreateProject);
    return !disabled && jsx("div", {
      sel: '.radio-btn'
    }, jsx(RadioButtonEl, {
      attrs: {
        selected: selectedOrganizationId === org.id,
        disabled
      },
      on: {
        click: () => !disabled && this.update({
          selectedOrganizationId: org.id
        })
      }
    }, org.name));
  }))), jsx("div", {
    sel: '.project-creation-btn-area'
  }, !isSetup && jsx(ButtonEl, {
    sel: '.skip-btn',
    attrs: {
      theme: ButtonTheme.Tertiary,
      role: "button",
      tabindex: 0
    },
    on: {
      click: this.helpers.clickedCancel
    }
  }, "Cancel"), jsx(ButtonEl, {
    sel: '.create-btn',
    attrs: {
      theme: ButtonTheme.Primary,
      role: "button",
      tabindex: 0,
      disabled: !projectName || !projectName.trim() || !selectedTimezone
    },
    on: {
      click: this.helpers.createProject
    }
  }, "Create"))));
}